import { createIntlCache } from 'react-intl';

export default createIntlCache();
